const ManageInvoiceMenu = (props: any) => (
    <svg
        width={24}
        height={25}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14 3.32324V7.32324C14 7.58846 14.1054 7.84281 14.2929 8.03035C14.4804 8.21789 14.7348 8.32324 15 8.32324H19"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17 21.3232H7C6.46957 21.3232 5.96086 21.1125 5.58579 20.7375C5.21071 20.3624 5 19.8537 5 19.3232V5.32324C5 4.79281 5.21071 4.2841 5.58579 3.90903C5.96086 3.53396 6.46957 3.32324 7 3.32324H14L19 8.32324V19.3232C19 19.8537 18.7893 20.3624 18.4142 20.7375C18.0391 21.1125 17.5304 21.3232 17 21.3232Z"
            stroke="#98A2B3"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ManageInvoiceMenu;
